import {IUserDetails} from "@bounce/shared/consumer/declarations";
import {BaseQueryOptions, BaseUseQueryResult, useBaseQuery} from "@bounce/shared/requests";
import {AxiosResponse} from "axios";
import {axiosConsumerAppInstance} from "~/api/ConsumerApiManager";

type Variables = {
  userId?: string;
};

type Data = IUserDetails | undefined;

export const getUserDetails = async (): Promise<Data> => {
  const result = await axiosConsumerAppInstance.get<Data, AxiosResponse<Data>>(`/user/get_user_details`);
  return result.data;
};

export const useGetUserClientDetailsQuery = (
  variables: Variables,
  options?: BaseQueryOptions<Data, Variables>
): BaseUseQueryResult<Data> => {
  return useBaseQuery<Data, Variables>(["user", variables.userId, "frontend"], getUserDetails, variables, options);
};
